<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar title="设置" left-arrow @click-left="$router.go(-1)" />
    </van-sticky>
    <van-cell-group>
      <!-- <van-uploader :after-read="upHeadImg">
        <van-cell title="头像" is-link>
          <div slot="default">
            <img
              :src="userInfo.head_image"
              v-if="userInfo.head_image"
              style="width: 40px;height: 40px;"
            />
            <img src="../../assets/imgs/personal/upImg.png" v-else style="width: 40px;height: 40px;" />
          </div>
        </van-cell>
      </van-uploader>
      <van-field
        label="昵称"
        placeholder="请输入昵称"
        is-link
        v-model="userInfo.nick_name"
        input-align="right"
      /> -->
      <van-cell title="手机号"  :value="userInfo.phone.substr(0,3)+'****'+userInfo.phone.substr(7)" />
      <van-cell title="真实姓名"  :value="userInfo.name" />
      <van-cell title="注册时间" :value='userInfo.create_time'/>
      <van-cell title="管理收货地址" is-link to="myAddress" />
      <!-- <van-cell title="收款管理" is-link to="gather" /> -->
      <van-cell title="修改登录密码" is-link to="resetPsd" />
      <!-- <van-cell title="修改交易密码" is-link to="resetpayPsd" /> -->
    </van-cell-group>
    <!-- <van-button style="margin-top: 60px;" @click="saveuser">保存</van-button> -->
    <van-button @click="submit">退出登录</van-button>
  </div>
</template>

<script>
import { editUserInfo, fileUpload, userInfo } from "@/api/personal";
export default {
  data() {
    return {
      userInfo: {
      },
    
    };
  },
  created() {
    userInfo().then(res => {
      this.userInfo=res;
    });

  },
  methods: {
    saveuser() {
      editUserInfo(this.userInfo).then(res => {
        this.$toast('修改成功');
      });
    },
    upHeadImg(file) {
      let formData = new FormData();
      formData.append("image", file.file);
      fileUpload(formData).then(res => {
        this.userInfo.head_image = res.path;
      });
    },
    // 退出登录
    submit() {
      localStorage.removeItem("userToken");
      this.$router.push({ name: "Login" });
    }
  }
};
</script>
<style scoped lang='less'>
.van-uploader {
  width: 100%;

  div {
    width: 100%;
  }
}
/deep/.van-uploader__input-wrapper {
  width: 100%;
}
.van-uploader__input {
  width: 100%;
}
/deep/.van-cell {
  width: 100%;
}
.wrap {
  width: 100%;
  height: 100%;
}

.gap {
  width: 100%;
  height: 10px;
  background: #faf7fa;
}

.van-button {
  width: 90%;
  color: white;
  display: block;
  background:#3B6BFB;
  font-size: 16px;
  margin: 100px auto 0;
  border-radius: 25px;
}
</style>